module.exports = __webpack_public_path__ + "img/prize-sty-light.e904d701.png";